module.exports = __webpack_public_path__ + "static/media/logo-assets-artwork.2c1a092a.jpg";